module.exports = ".hidden {\r\n    display: none;\r\n}\r\n\r\nbutton[disabled].active {\r\n    background-color: #34bfa3 !important;\r\n}\r\n\r\nbutton[disabled]:hover {\r\n    color: white !important;\r\n}\r\n\r\n.bold-font {\r\n    font-weight: bold !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/criteria-selection/criteria-selection.component.css
// module id = ./src/app/shared/components/criteria-selection/criteria-selection.component.css
// module chunks = main